export const FONTS = [
  { name: 'Abril Fatface' },
  { name: 'AG Buch Condensed BQ', pwaDisabled: true },
  { name: 'Adorn Condensed Sans' },
  { name: 'Airstream', pwaDisabled: true },
  { name: 'Alegreya Sans SC', hasItalic: true, hasBold: true },
  { name: 'Alégre Sans NC' },
  {
    name: 'Asahi Super Dry Display',
    exclusiveBrandOrMarket: [{ brandId: '56', marketId: '252' }],
  },
  {
    name: 'Asahi Super Dry Sans',
    hasBold: true,
    exclusiveBrandOrMarket: [{ brandId: '56', marketId: '252' }],
  },
  {
    name: 'Asahi Super Dry Sans Light',
    exclusiveBrandOrMarket: [{ brandId: '56', marketId: '252' }],
  },
  { name: 'Avenir', hasItalic: true, hasBold: true },
  {
    name: 'BACARDI Headline Display',
    exclusiveBrandOrMarket: [{ brandId: '2' }],
  },
  {
    name: 'BACARDI Secondary Text',
    exclusiveBrandOrMarket: [{ brandId: '2' }],
  },
  {
    name: 'Barlow Condensed',
    hasItalic: true,
    hasBold: true,
    pwaDisabled: true,
  },
  {
    name: 'Barlow Condensed Medium',
    hasItalic: true,
  },
  { name: 'Baskerville BT' },
  { name: 'Bebas Neue' },
  { name: 'Belleza' },
  { name: 'Bentham', pwaDisabled: true },
  { name: 'Bitter' },
  { name: 'Bodoni 72', hasItalic: true },
  { name: 'Bodoni 72 Oldstyle', hasItalic: true, pwaDisabled: true },
  { name: 'Bodoni 72 Smallcaps' },
  {
    name: 'Brandon Grotesque',
    exclusiveBrandOrMarket: [
      { brandId: '4', marketId: '6' },
      { brandId: '4', marketId: '121' },
    ],
  }, //Molson - UK, Ireland
  { name: 'ByMyHand' },
  { name: 'Cantata One' },
  { name: 'Cardenio Modern' },
  {
    name: 'Carlsberg Sans',
    exclusiveBrandOrMarket: [{ brandId: '24', marketId: '88' }],
  }, // Carlsberg Global - Canada
  { name: 'Clarendon BT', pwaDisabled: true },
  { name: 'Clarendon Lt BT' },
  { name: 'Copperplate' },
  { name: 'Cutive', pwaDisabled: true },
  { name: 'Cutive Mono' },
  {
    name: 'Cyclone',
    exclusiveBrandOrMarket: [{ brandId: '24', marketId: '88' }],
  }, // Carlsberg Global - Canada
  { name: 'Dancing Script' },
  { name: 'EB Garamond', hasItalic: true, hasBold: true },
  { name: 'EcuyerDAX' },
  { name: 'Euphoria Script' },
  { name: 'Fira Sans Extra Condensed', hasItalic: true, hasBold: true },
  { name: 'Fjalla One' },
  {
    name: 'Fritz-Kola International',
    exclusiveBrandOrMarket: [{ brandId: '47' }, { brandId: '8' }],
  },
  { name: 'Futura', hasItalic: true },
  {
    name: 'FuturaBT',
    exclusiveBrandOrMarket: [{ brandId: '24', marketId: '88' }],
  }, // Carlsberg Global - Canada
  { name: 'Gill Sans' },
  { name: 'Gill Sans MT', hasItalic: true, hasBold: true },
  { name: 'Gotham' },
  { name: 'Goudy Old Style', pwaDisabled: true },
  { name: 'Great Vibes', pwaDisabled: true },
  { name: 'Handserif' },
  { name: 'HansHand', pwaDisabled: true },
  { name: 'Helvetica', hasItalic: true, hasBold: true },
  { name: 'HelveticaNeue-Light' },
  { name: 'HelveticaNeue-Medium' },
  { name: 'Inria Serif', hasItalic: true, hasBold: true },
  { name: 'Italiana', pwaDisabled: true },
  {
    name: 'Jacobsen Grotesk Caps',
    exclusiveBrandOrMarket: [{ brandId: '24', marketId: '88' }],
  }, // Carlsberg Global - Canada
  { name: 'Jasper Daniels', exclusiveBrandOrMarket: [{ brandId: '35' }] }, // Brown-Forman
  { name: 'Josefin Sans', hasItalic: true },
  { name: 'Josefin Slab', hasItalic: true },
  { name: 'Jura', hasBold: true },
  {
    name: 'JW Headline',
    exclusiveBrandOrMarket: [{ brandId: '1' }],
  },
  {
    name: 'JW Serif',
    hasBold: true,
    hasItalic: true,
    exclusiveBrandOrMarket: [{ brandId: '1' }],
  },
  {
    name: 'JW Blue Label Gothic',
    exclusiveBrandOrMarket: [{ brandId: '1' }],
  },
  { name: 'Kameron', hasBold: true },
  {
    name: 'Knockout',
    displayName: 'Guinness Knockout',
    exclusiveBrandOrMarket: [
      { brandId: '1', marketId: '1' },
      { brandId: '1', marketId: '69' },
    ],
  },
  {
    name: 'Kronenbourg 1664',
    exclusiveBrandOrMarket: [{ brandId: '24', marketId: '88' }],
  }, // Carlsberg Global - Canada
  { name: 'Kumbh Sans' },
  { name: 'Kurale' },
  { name: 'Lexend', hasBold: true },
  {
    name: 'Lillet Begum',
    hasItalic: true,
    hasBold: true,
    exclusiveBrandOrMarket: [
      { brandId: '10', marketId: '12' },
      { brandId: '10', marketId: '116' },
      { brandId: '10', marketId: '123' },
      { brandId: '10', marketId: '127' },
      { brandId: '10', marketId: '130' },
      { brandId: '10', marketId: '141' },
      { brandId: '10', marketId: '239' },
    ],
  },
  {
    name: 'Lillet Mostra Nuova AltD',
    hasBold: true,
    exclusiveBrandOrMarket: [
      { brandId: '10', marketId: '12' },
      { brandId: '10', marketId: '141' },
      { brandId: '10', marketId: '132' },
      { brandId: '10', marketId: '123' },
      { brandId: '10', marketId: '130' },
      { brandId: '10', marketId: '116' },
      { brandId: '10', marketId: '127' },
      { brandId: '10', marketId: '239' },
    ],
  },
  {
    name: 'Lillet Shimmer OT',
    hasBold: true,
    exclusiveBrandOrMarket: [
      { brandId: '10', marketId: '12' },
      { brandId: '10', marketId: '141' },
      { brandId: '10', marketId: '132' },
      { brandId: '10', marketId: '123' },
      { brandId: '10', marketId: '130' },
      { brandId: '10', marketId: '116' },
      { brandId: '10', marketId: '127' },
      { brandId: '10', marketId: '239' },
    ],
  },
  { name: 'Literata', hasItalic: true, hasBold: true },
  { name: 'Lora', hasItalic: true },
  { name: 'Lubalin Graph Demi', pwaDisabled: true },
  { name: 'Luna', pwaDisabled: true },
  { name: 'Marcellus' },
  {
    name: 'Martini Torino',
    hasBold: true,
    exclusiveBrandOrMarket: [{ brandId: '2' }],
  },
  { name: 'Minion Pro' },
  { name: 'Motlow Caps', exclusiveBrandOrMarket: [{ brandId: '35' }] }, // Brown-Forman
  { name: 'Neucha' },
  { name: 'Notable' },
  { name: 'Nunito Sans', hasItalic: true, hasBold: true },
  {
    name: 'Ny Carlsberg Display',
    exclusiveBrandOrMarket: [{ brandId: '24', marketId: '88' }],
  }, // Carlsberg Global - Canada
  { name: 'OfficinaSansStd-Book', hasItalic: true, hasBold: true },
  { name: 'OfficinaSerifStd-Book', hasItalic: true, hasBold: true },
  { name: 'Open Sans', hasItalic: true, hasBold: true },
  { name: 'Optima', hasItalic: true, hasBold: true },
  { name: 'Oranienbaum' },
  { name: 'Oswald' },
  { name: 'Parisienne' },
  {
    name: 'Patron Serif Office',
    hasBold: true,
    exclusiveBrandOrMarket: [
      { brandId: '2', marketId: '70' },
      { brandId: '2', marketId: '36' },
      { brandId: '2', marketId: '32' },
      { brandId: '2', marketId: '46' },
      { brandId: '2', marketId: '220' },
      { brandId: '2', marketId: '124' },
      { brandId: '2', marketId: '76' },
      { brandId: '2', marketId: '72' },
      { brandId: '2', marketId: '71' },
      { brandId: '2', marketId: '79' },
      { brandId: '2', marketId: '52' },
      { brandId: '2', marketId: '45' },
      { brandId: '2', marketId: '48' },
      { brandId: '2', marketId: '53' },
      { brandId: '2', marketId: '3' },
    ],
  },
  { name: 'Pattaya' },
  { name: 'Play', hasBold: true },
  { name: 'Playfair Display', hasItalic: true },
  {
    name: 'Poppins Light',
    hasItalic: true,
  },
  { name: 'Quattrocento', hasBold: true },
  { name: 'QuickSand' },
  { name: 'Roboto', hasItalic: true, hasBold: true },
  { name: 'Roboto Slab', hasBold: true },
  { name: 'Rokkitt' },
  { name: 'Rubik Mono One' },
  { name: 'Sacramento', pwaDisabled: true },
  { name: 'Sanchez', hasItalic: true },
  { name: 'Satisfy', pwaDisabled: true },
  { name: 'Sheila', pwaDisabled: true },
  { name: 'SmithyXT-Faded' },
  {
    name: 'Somersby Header 2019',
    exclusiveBrandOrMarket: [{ brandId: '24', marketId: '88' }],
  }, // Carlsberg Global - Canada
  {
    name: 'St~Germain Display',
    displayName: 'St Germain Header',
    exclusiveBrandOrMarket: [
      { brandId: '2', marketId: '3' },
      { brandId: '2', marketId: '32' },
      { brandId: '2', marketId: '36' },
      { brandId: '2', marketId: '45' },
      { brandId: '2', marketId: '46' },
      { brandId: '2', marketId: '48' },
      { brandId: '2', marketId: '56' },
      { brandId: '2', marketId: '50' },
      { brandId: '2', marketId: '52' },
      { brandId: '2', marketId: '53' },
      { brandId: '2', marketId: '70' },
      { brandId: '2', marketId: '71' },
      { brandId: '2', marketId: '72' },
      { brandId: '2', marketId: '76' },
      { brandId: '2', marketId: '79' },
      { brandId: '2', marketId: '80' },
      { brandId: '2', marketId: '124' },
      { brandId: '2', marketId: '220' },
    ],
  },
  { name: 'Stag' },
  { name: 'Steelworks paint', pwaDisabled: true },
  { name: 'Tenor Sans' },
  { name: 'Times New Roman', hasItalic: true, hasBold: true },
  { name: 'Varela Round', pwaDisabled: true },
  { name: 'Veneer' },
  { name: 'Work Sans', pwaDisabled: true, hasItalic: true },
  { name: 'Zilla Slab', hasItalic: true, hasBold: true },
];
